import { render } from "./InvoiceOverview.vue?vue&type=template&id=31ccabbc"
import script from "./InvoiceOverview.vue?vue&type=script&lang=js"
export * from "./InvoiceOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__